import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { BaseUser } from "src/stores/models/user";
import { getUserDisplayName } from "src/utils/user";

export const UserSelect = ({
  value,
  users,
  onChange,
  emptyLabel = "Not selected",
  disableClear = false,
  ...props
}: Omit<TextFieldProps, "value" | "onChange" | "select"> & {
  value: BaseUser | null | undefined;
  users: BaseUser[];
  onChange: (user: BaseUser | null) => void;
  emptyLabel?: string;
  disableClear?: boolean;
}) => {
  const selectedValue = value?.id ?? "";
  const selectedValueMissing =
    !!value && !users.some((user) => user.id === value.id);
  const missingValueLabel = value ? getUserDisplayName(value) : "";
  const userOptions = users.map((user) => ({
    id: user.id,
    label: getUserDisplayName(user),
  }));
  return (
    <TextField
      {...props}
      select
      size="small"
      value={selectedValue}
      onChange={(event) =>
        onChange(users.find((user) => user.id === event.target.value) ?? null)
      }
    >
      <MenuItem value="" disabled={disableClear}>
        {emptyLabel}
      </MenuItem>
      {selectedValueMissing && (
        <MenuItem value={selectedValue} disabled>
          {missingValueLabel}
        </MenuItem>
      )}
      {userOptions.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          {user.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
